import axios from '@/libs/axios'

export default {
  createCheckoutSession(payload) {
    return axios.post('/payments/create-session', payload)
  },
}
